/**
 * survey API
 *
 * @author minkyoung.park@emcast.com
 */
import httpService from "@/api/httpService";

const surveyApi = {
  // 게스트 단독시험 목록(get independent surveys list for guest)
  //https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_survey.html#resources-guest-survey-independent-fetch-page
  guestSurveyIndependentList(params) {
    return httpService.get(`/survey/independent`, params);
  },

  // 게스트 카테고리 기준 목록(get category independent surveys list for guest)
  //https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_survey.html#resources-guest-survey-independent-fetch-categorization
  guestSurveyIndependentCategoryList(params) {
    return httpService.get(`/survey/independent/categorization`, params);
  },

  // 게스트 시험 목록 개수(get independent surveys count for guest)
  // https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_exam.html#resources-guest-exam-independent-fetch-count
  guestSurveyIndependentCount(params) {
    return httpService.get(`/survey/independent/count`, params);
  },

  // 게스트 단독 설문 상세(get independent survey detail for guest)
  // https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_survey.html#resources-guest-survey-independent-fetch-detail
  guestSurveyIndependentView(params) {
    return httpService.get(`/survey/independent/${params.distId}`);
  },

  // 게스트 단독 설문 배지 목록(get independent survey badges list for guest)
  // https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_survey.html#resources-guest-survey-independent-badges
  guestSurveyIndependentViewBadges(params) {
    return httpService.get(`/survey/independent/${params.distId}/badges`);
  },

  // 단독 설문 상세(get independent survey detail)
  // https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-independent-fetch-detail
  surveyIndependentView(params) {
    return httpService.get(`/survey/independent/${params.distId}`);
  },

  // 설문 응답 초기 화면(get independent survey intro)
  // https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-respondent-intro
  surveyRespondentIntro(params) {
    return httpService.get(`/survey/respondent/${params.respondentId}/intro`);
  },

  // 설문 응답 시작(set independent survey start)
  // https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-respondent-start
  surveyRespondentStart(params) {
    return httpService.post(`/survey/respondent/${params.respondentId}/start`);
  },

  // 설문 응답창(get independent survey respondent window)
  // https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-respondent-window
  surveyRespondentWindow(params) {
    return httpService.get(`/survey/respondent/${params.respondentId}/window`);
  },

  // 설문지 그룹 목록(get independent survey question list)
  // https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-respondent-group-list
  surveyRespondentGroups(params) {
    return httpService.get(`/survey/respondent/${params.respondentId}/groups`);
  },

  // 설문 참여(enter independent survey)
  // https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-independent-enter
  surveyIndependentEnter(params) {
    return httpService.post(`/survey/independent/${params.distId}/enter`);
  },

  // 설문지 제출(sumbit independent survey)
  //https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-respondent-paper-submit
  surveyRespondentSubmit(params) {
    return httpService.put(
      `/survey/respondent/${params.respondentId}/submit`,
      params.answers
    );
  },

  // 설문지 제출(sumbit independent survey) - 온라인클래스
  surveyLearnRespondentSubmit(params) {
    return httpService.put(`/learn/learner/online/${params.learnId}/respondent/${params.respondentId}/submit`, params.answers)
  },

  // 설문지 제출(sumbit independent survey) - 스킬패스
  surveyMicroLearnRespondentSubmit(params) {
    return httpService.put(`/micro/learn/learner/online/${params.learnId}/respondent/${params.respondentId}/submit`, params.answers)
  },

  // 설문 제출 결과(get independent survey submited result)
  //https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-respondent-paper-submit-result
  surveyRespondentResult(params) {
    return httpService.get(
      `/survey/respondent/${params.respondentId}/submit/result`
    );
  },

  // 설문 제출 결과 피드백(get independent survey submited result feedback)
  //https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-respondent-paper-result
  surveyRespondentFeedback(params) {
    return httpService.get(`/survey/respondent/${params.respondentId}/result`);
  },

  // 설문 순위선택향 문항 피드백 조회(get Survey Rank Selection Question Feedback)
  //https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-respondent-paper-result
  surveyQuestionRankingChoiceFeedback(params) {
    return httpService.get(
      `/survey/question/${params.questionId}/view/${params.choiceId}/selections`
    );
  },

  // 나의 설문 목록(get my independent survey list)
  //https://clpapi.tinkeredu.co.kr/static/docs/survey.html#resources-survey-respondent-fetch-page
  myIndependentSurveyList(params) {
    return httpService.get(`/survey/respondent`, params);
  },

  //설문 카운트( get my independent Survey Count)
  //http://13.230.87.17:8080/static/docs/survey_respondent.html#resources-survey-respondent-count
  surveyCount() {
    return httpService.get(`/survey/respondent/count`);
  },

  // 서베이 인사이트 페이지 조회(survey insight fetch)
  //https://dev.clp.kr/spc/api/static/docs/survey.html#resources-survey-insight-fetch_http_request
  myIndependentSurveyListResult(params) {
    return httpService.get(`/survey/insight`, params);
  },

  // 서베이 인사이트 상세 조회(survey insight detail)
  // https://dev.clp.kr/spc/api/static/docs/survey.html#resources-survey-insight-detail
  surveyInsightView(params) {
    return httpService.get(`/survey/insight/stats`, params);
  }
};

// export const
export default surveyApi;
